@if (deviceViewService.layout !== LayoutVariants.DESKTOP) {
	<span #primaryEl class="marquee" [class.scrollAutomatic]="shouldScroll()">
		{{ text() }}
	</span>
} @else {
	<span #primaryEl class="marquee" [class.scroll]="shouldScroll()">
		{{ text() }}
	</span>
}
